<div class="container">
  <div>
    <div class="bar">
      @for (step of steps; track step) {
        <div class="step" [class.current]="step === activeStep"></div>
      }
    </div>
    @if (title) {
      <ion-label class="title">{{ title }}</ion-label>
    }
  </div>
</div>
